import { createContext, useContext } from 'react';

export type FormsSteps = 'signup' | 'email' | 'mobileNumber' | 'success';

type SetActiveStep = (step: FormsSteps) => void;

export interface SignupPageContextValue {
  activeStep: FormsSteps;
  setActiveStep: SetActiveStep;
}

const SignupPageContext = createContext({
  activeStep: 'signup',
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- Keep the default function empty, we will configure it later
  setActiveStep: (_step: FormsSteps) => {},
});

export const useSetActiveStep = (): SetActiveStep => {
  const { setActiveStep } = useContext(SignupPageContext);

  return setActiveStep;
};

export const SignupFormProvider = SignupPageContext.Provider;
